// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const nullLaf: LookAndFeel = {
  code: 'null',
  displayName: 'Null Checkout',
  getRootComponent: () => import('./null-root'),
  prsSupport: {
    integrations: {},
    features: [],
  },
};

export default nullLaf;
